import prefetchImages from 'prefetch-image'

const hoverImages = [
  '/images-optimized/Icon_Pruefung_ani.gif',
  '/images-optimized/Icon_Termin_ani.gif',
  '/images-optimized/Icon_Foto_ani.gif',
]

prefetchImages(hoverImages, {}).catch(() => {
  /* best-effort preload */
})

const hasDollar = () => typeof window !== 'undefined' && !!window.$

const setupChoiceTiles = () => {
  const selector = "*[data-ani='next-step-tile']"
  if (!hasDollar()) return () => {}

  const enterHandler = function () {
    const imgs = $(this).find('img')
    $(imgs[0]).addClass('hidden')
    $(imgs[1]).removeClass('hidden')
  }
  const leaveHandler = function () {
    const imgs = $(this).find('img')
    $(imgs[0]).removeClass('hidden')
    $(imgs[1]).addClass('hidden')
  }

  $(selector).on('mouseenter', enterHandler)
  $(selector).on('mouseleave', leaveHandler)

  return () => {
    $(selector).off('mouseenter', enterHandler)
    $(selector).off('mouseleave', leaveHandler)
  }
}

export const setupEstimateResult = () => {
  if (!hasDollar()) return () => {}

  window.jQuery = window.$
  const teardownChoiceTiles = setupChoiceTiles()
  return () => {
    teardownChoiceTiles?.()
  }
}
